import { required, size } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"

extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
})

const resetPassword = {
    components: { ValidationProvider, ValidationObserver },
    data: () => ({
        loading: false,
        step: 1,
        imageUrl: '/imgs/Business-Background-PNG.png',
        rememberMe: false,
        user: {
            password: null,
            password_confirmation: null
        }
    }),
    methods: {
        async reset() {
            this.loading = true;
            var payload = {
                password: this.user.password,
                password_confirmation: this.user.password_confirmation,
                documento: sessionStorage.getItem('token')
            };

            if (!this.validatePasswordFront(payload)) {
                return false;
            }

            if(payload.password.length <8 ){
                this.loading = false;
                this.alertError('la contraseña debe de 8 digitos o mas')
                return false;
            }

            try {
                const response = await this.$axios.post('/reset/password', payload);
                if(response.data.status){
                    this.$router.push("/main");
                } else {
                    this.loading = false;
                    this.alertError(response.data.msg);
                }
            } catch (error) {
                this.loading = false;
                    this.alertError("a ocurrido un error intenta de nuevo");
            }

        },
        validatePasswordFront(payload) {
            if (payload.password != payload.password_confirmation) {
                this.loading = false;
                this.alertError('Las contraseñas no coinciden');
                return false;
            }
            return true;
        },
        alertError(msg = ''){
            this.$toast.error(msg, {
                position: "bottom-left",
                timeout: 3436,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: false,
                draggable: true,
                draggablePercent: 0.38,
                showCloseButtonOnHover: true,
                hideProgressBar: false,
                closeButton: false,
                icon: true,
                rtl: false
            });
        }
    }
}

export default resetPassword;